/** Operational-aligned instructor roster tabs (must match backend instructor_roster_operational_tabs.py). */

export const OPERATIONAL_ROSTER_TABS = [
  { value: "active", label: "Active" },
  { value: "on_hold", label: "On Hold" },
  { value: "completed", label: "Completed" },
  { value: "withdrawn", label: "Withdrawn" },
  { value: "archived", label: "Archived" },
  { value: "review", label: "Review" },
  { value: "all", label: "All" },
];

export function operationalLifecycleTab(learner) {
  const tab = (learner.operational_lifecycle_tab || "").toLowerCase();
  if (tab) return tab;
  const bucket = (learner.operational_mirror_source_bucket || "").toLowerCase();
  const assignStatus = (learner.assignment_status || learner.status || "active").toLowerCase();
  if (bucket === "review_unknown") return "review";
  if (bucket === "unlinked") {
    if (assignStatus === "removed") return "withdrawn";
    if (assignStatus === "on_hold") return "on_hold";
    return "active";
  }
  if (bucket === "working_hold") return "on_hold";
  if (bucket === "archive_source") return "archived";
  return "active";
}

export function isManualRosterArchived(learner) {
  return (
    learner.manual_roster_archived === true ||
    (learner.roster_list_status || "").toLowerCase() === "archived"
  );
}

export function learnerMatchesOperationalTab(learner, listTab) {
  const tab = (listTab || "active").toLowerCase();
  if (tab === "all") return true;
  if (tab === "review") return operationalLifecycleTab(learner) === "review";
  if (isManualRosterArchived(learner)) return false;
  return operationalLifecycleTab(learner) === tab;
}

export function computeOperationalTabCounts(learners, serverCounts = null) {
  if (serverCounts) return serverCounts;
  const counts = {
    active: 0,
    on_hold: 0,
    completed: 0,
    withdrawn: 0,
    archived: 0,
    review: 0,
    all: 0,
  };
  for (const l of learners) {
    counts.all += 1;
    const otab = operationalLifecycleTab(l);
    if (otab === "review") counts.review += 1;
    else if (!isManualRosterArchived(l) && counts[otab] !== undefined) counts[otab] += 1;
  }
  return counts;
}
